export const AGENTBOX_EMAIL_TEMPLATE = {
  to: 'support@agentbox.com.au',
  cc: 'help@snug.com',
  subject: 'Enable Snug as Upload Destination - Agency Setup',
  body: `Hello Agentbox

Could you please enable Snug as an upload destination for our agency for the Agentbox Account(s):

- [Enter your Agency ID here]

Please assign the Agentbox Agency ID and provide it to us.

Thank you,

Head of Property Management`,
}
